<template>
    <div class="main-container">
    <add-employee></add-employee>
    </div>
</template>

<script>
import addEmployee from "@/modules/onboarding/views/pages/le-level/employees/AddEmployee.vue";

export default {
  components: {
    addEmployee
  }
}
</script>

<style lang="scss" scoped>
</style>
